import {Tooltip} from "rsuite";
import React from "react";

const textStyle = {
  fontSize: 14,
  lineHeight: 1,
}

const p1Style = {
  marginBottom: 5,
  paddingBottom: 0,
  marginTop: 10
}

export const linksTooltips = (toolTipText) => {
  return (
      <Tooltip style={{textAlign: 'left'}} >
        <p style={{textAlign: 'left', ...textStyle, ...p1Style}}>
          {toolTipText}
        </p>
      </Tooltip>
  )
}